import React, { useCallback } from "react";
import { useSelector } from "react-redux";

import ExamPlan from "./ExamPlan";
import ExamPlanIntroPopup from "./ExamPlanPopup/ExamPlanIntroPopup";
import ExamPlanNoticePopup from "./ExamPlanPopup/ExamPlanNoticePopup";
import { isExamPlanNoticePeriod, isExamPlanVisible, useExamPlan } from "./ExamPlanContext";

/**
 * 시험대비모드(시험 On) 플로팅 패널.
 * 노출 판정(isVisible)과 홈 여부(isHome)는 App 에서 한 곳으로 계산해 내려준다.
 * (컴포넌트가 경로를 다시 판정하면 App 의 조건과 어긋나 조용히 규칙이 깨진다)
 */
function ExamPlanFloating({ isVisible, isHome }) {
    const userId = useSelector((state) => state.loginReducer.userId);
    const mmbrSeq = useSelector((state) => state.loginReducer.mmbrSeq);

    const {
        examPlanInfo,
        popupInfo,
        openRequest,
        openExamPlan,
        openExamPlanPopup,
        closeExamPlanPopup,
        closeExamPlanPopupToday,
        refreshExamPlan,
    } = useExamPlan();

    const handlePopupComplete = useCallback(() => {
        openExamPlan();
        refreshExamPlan(false);
    }, [openExamPlan, refreshExamPlan]);

    const handleRequestSetup = useCallback(() => openExamPlanPopup(), [openExamPlanPopup]);

    const isPanelVisible = Boolean(isVisible && examPlanInfo && isExamPlanVisible(examPlanInfo));
    // 사전안내 팝업은 시험대비 영역이 아직 안 보이는 시작 전에 뜨므로 패널 노출과 따로 판단한다.
    const isNoticePopup = isExamPlanNoticePeriod(popupInfo);

    if (!isPanelVisible && !isNoticePopup) return null;

    return (
        <>
            {isPanelVisible && (
                <ExamPlan
                    userId={userId}
                    mmbrSeq={mmbrSeq}
                    examPlanInfo={examPlanInfo}
                    isSetupPending={examPlanInfo.JOIN_YN !== "Y"}
                    openRequest={openRequest}
                    onRequestSetup={handleRequestSetup}
                    isHome={isHome}
                />
            )}
            {isNoticePopup ? (
                <ExamPlanNoticePopup
                    isOpen={popupInfo}
                    missPlanInfo={popupInfo}
                    onClose={closeExamPlanPopup}
                    onCloseToday={closeExamPlanPopupToday}
                />
            ) : (
                <ExamPlanIntroPopup
                    isOpen={popupInfo}
                    missPlanInfo={popupInfo}
                    userId={userId}
                    mmbrSeq={mmbrSeq}
                    onClose={closeExamPlanPopup}
                    onCloseToday={closeExamPlanPopupToday}
                    onComplete={handlePopupComplete}
                />
            )}
        </>
    );
}

export default ExamPlanFloating;
